<app-dcabotorder *ngIf="orderStep == 'one'"></app-dcabotorder>
<app-dcabotpreview *ngIf="orderStep == 'two'" [botDetails]="botDetails"
    [orderPlaceDet]="orderPlaceDet"></app-dcabotpreview>
<app-dcabotdetails *ngIf="orderStep == 'three'"></app-dcabotdetails>
<app-dcabotstop *ngIf="orderStep == 'four'" [posDetails]="posDetails" [closeType]="closeType"></app-dcabotstop>
<app-dcabotaction *ngIf="orderStep == 'five'"></app-dcabotaction>
<!-- <app-dcabotcreate></app-dcabotcreate> -->
 